<template>
  <el-form ref="form" :model="formData" size="mini">
    <el-row :gutter="10">
      <el-col :lg="{span: 8}" :md="{span: 24}" :sm="{span: 24}">
        <el-form-item label="推送类型">
          <el-input v-model="formData.pushType" readonly> </el-input>
        </el-form-item>
      </el-col>
      <el-col :lg="{span: 8}" :md="{span: 24}" :sm="{span: 24}">
        <el-form-item label="推送时间">
          <el-input
            v-model="formData.pushTime"
            readonly
            prefix-icon="el-icon-date"
          >
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :lg="{span: 8}" :md="{span: 24}" :sm="{span: 24}">
        <el-form-item label="推送状态">
          <el-input v-model="formData.v_pushStatus" readonly> </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="24">
        <el-form-item label="推送数据">
          <el-input
            v-model="formData.pushData"
            type="textarea"
            rows="5"
            readonly
          >
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="24">
        <el-form-item label="推送响应结果">
          <el-input
            v-model="formData.pushReplyData"
            type="textarea"
            rows="5"
            readonly
          >
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
export default {
  props: {
    formData: {type: Object, default: () => {}},
    disabled: {type: Boolean, default: false},
  },
}
</script>
